import React from 'react';
import {Container, Row, Col, Card} from 'react-bootstrap';

// Define types for props
interface ClientAddress {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

interface ClientContact {
  contactfullname: string;
  email: string;
  phone: string;
  faxnumber: string;
}

interface ClientDetailsProps {
  result: StakeholderData[];
  StakeholderName?: string;
}

interface Address {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
}

interface Contact {
  contactfullname?: string;
  emailAddress?: string;
  phoneNumber?: string;
  faxNumber?: string;
}

interface StakeholderData {
  stakeholderName?: string;
  addressesJson?: Address[];
  contactsJson?: Contact[];
}

const StakeholderCardDetails: React.FC<ClientDetailsProps> = ({
  result,
  StakeholderName,
}) => {
  if (!result || result.length === 0) return null;

  const formattedData = {
    clientName: result[0]?.stakeholderName || '',
    clientAddress: result.flatMap(
      (item) =>
        item.addressesJson?.map((address) => ({
          street1: address.addressLine1 || '',
          street2: address.addressLine2 || '',
          street3: address.addressLine3 || '',
          city: address.city || '',
          state: address.state || '',
          zip: address.zipCode || '',
          country: address.country || '',
        })) || [],
    ),
    clientContacts: result.flatMap(
      (item) =>
        item.contactsJson?.map((contact) => ({
          contactfullname: contact.contactfullname || '',
          email: contact.emailAddress || '',
          phone: contact.phoneNumber || '',
          faxnumber: contact.faxNumber || '',
        })) || [],
    ),
  };

  return (
    <Container style={{maxWidth: '100%'}}>
      <Row>
        <Col className='mx-0 px-0'>
          <div className='autoSizeContent'>
            <div>
              <div className='cardTitle d-flex align-items-center'>
                <span className='material-icons mx-1 text-secondary'>
                  person
                </span>
                {StakeholderName}
              </div>
              <div className='d-flex align-items-center'>
                <strong> {formattedData?.clientName}</strong>
              </div>
            </div>
            <div>
              <div className='cardTitle d-flex align-items-center'>
                <span className='material-icons me-1 text-secondary'>
                  account_balance
                </span>
                Address
              </div>
              {formattedData.clientAddress.map((address, index) => (
                <div className='card '>
                  <div className='card-body p-2'>
                    <div className='card-text'>
                      {address.street1}
                      <br />
                      {(address.street2 || address.street3) && (
                        <>
                          {address.street2}
                          {address.street2 && address.street3 ? ', ' : ''}
                          {address.street3}
                          <br />
                        </>
                      )}
                      {address.city}, {address.state}, {address.country}
                      <br />
                      {address.zip}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div>
              <div className='cardTitle d-flex align-items-center'>
                {' '}
                <span className='material-icons mx-1 text-secondary'>
                  restart_alt
                </span>
                Contact
              </div>
              {formattedData.clientContacts.map((contact, index) => (
                <div className='card'>
                  <div className='card-body p-2'>
                    <div className='card-text'>
                      {contact.contactfullname}
                      <br />
                      {contact.email}
                      <br />
                      {contact.phone} <br />
                      {contact.faxnumber}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StakeholderCardDetails;
